const contentMargins = ['12px', null, null, '24px'];
export const bleedMargins = ['-12px', null, null, '-24px'];

export default contentMargins;